import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PracticeCallPage } from '@/pages/guides/practice-call/PracticeCallPage';
import { PRACTICE_CALL_ORIGINS } from '@/pages/guides/practice-call/practice-call-origin';

const practiceCallSearchSchema = z.object({
	from: z.enum(PRACTICE_CALL_ORIGINS).optional().catch(undefined),
});

export const Route = createFileRoute('/_authenticated/practice-call')({
	validateSearch: practiceCallSearchSchema,
	component: PracticeCallPage,
});
